"use client";

import { motion } from "framer-motion";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { itemVariants } from "@/lib/animation-variants";

export default function RegistrationStatusCard() {
  return (
    <motion.div variants={itemVariants}>
      <Card variant="feature" title="Wichtige Hinweise">
        <CardHeader />
        <CardContent>
          <div className="space-y-2">
            <p className="text-sm font-semibold text-gothia-green">
              Festkommers & Festball — ausverkauft
            </p>
            <p className="text-body-sm text-gray-700">
              Der Festkommers und der Festball sind ausverkauft. Eine Anmeldung
              ist für beide Veranstaltungen leider nicht mehr möglich.
            </p>
          </div>

          <div className="space-y-2 border-t border-gothia-gold/30 pt-4">
            <p className="text-sm font-semibold text-gothia-green">
              Begrüßungsabend & Ausklang auf dem Haus — ohne Anmeldung
            </p>
            <p className="text-body-sm text-gray-700">
              Der Begrüßungsabend und der Ausklang auf dem Haus können auch
              spontan und ohne Anmeldung besucht werden.
            </p>
          </div>
        </CardContent>
      </Card>
    </motion.div>
  );
}
